import { Localidad } from '../../models/localidad.model';
import { Evento } from './../evento.model';
import { EventoDataService } from './../../service/data/evento-data.service';
import { Component,  OnInit } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';
import { MensajeComponent } from 'src/app/mensaje/mensaje.component';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe, registerLocaleData } from '@angular/common';
import { MetaPixelService } from '../meta-pixel/meta-pixel.service';
import localeES from '@angular/common/locales/es';
import e from 'cors';
import { SeoService } from 'src/app/service/seo.service';
import { TiktokPixelService } from '../tiktok-pixel/tiktok-pixel.service';
import { MensajeImgComponent } from 'src/app/mensaje-img/mensaje-img.component';
import { GoogleAnalyticService } from '../google-analytic/google-analytic.service';
import { error } from 'console';
import { getMatIconFailedToSanitizeLiteralError } from '@angular/material/icon';
import { ignoreElements } from 'rxjs';



@Component({
    selector: 'app-eventos-perfil',
    templateUrl: './eventos-perfil.component.html',
    styleUrls: ['./eventos-perfil.component.css'],
    standalone: false
})
export class EventosPerfilComponent implements OnInit {
  miId: string;
  evento: Evento;
  mapaUrl;
  safeSrc = null;
  fecha: Date;
  fechaActual: Date = new Date();
  localidades: Localidad[] = [];
  cargando= false;
  mapaV: boolean;
  organizadorId;
  organizadorNombre: string;
  pulep: boolean = false;
  codigoVenta: string;
  meses: number;
  semanas: number;
  dias: number;
  horas: number;
  minutos: number;
  segundos: number;
  listaImagenes:string[]
  



  constructor(
    private route: ActivatedRoute,
    private meta: Meta,
    private title: Title,
    private dialog: MatDialog,
    private service: EventoDataService,
    private sanitizer: DomSanitizer,
    private metaPixelService: MetaPixelService,
    private seoService: SeoService,
    private tiktokPixelService: TiktokPixelService,
    private googleAnalyticService: GoogleAnalyticService,
    private router: Router

  ) {}

  ngOnInit(): void {
    this.mapaV = false;
    this.listaImagenes=[]
    this.evento = new Evento();
    this.evento.fecha = null;
    this.evento.fechaFin = null;
    this.evento.imagenes = [];
    this.evento.adicionales = [];
    this.cargando = true;

    this.route.paramMap.subscribe((params) => {
      this.miId = params.get('id');
      this.codigoVenta = params.get('codigoVenta');

      const pulep = Number(this.miId)
      
      if(isNaN(pulep)){
        this.service.getEventoIdPerfilPulep(this.miId).subscribe((response: any)=>{
          this.miId = response
          this.getEventoPerfil();
          
        })
      }
      else{
        this.getEventoPerfil();
      }
    });
  }

  getEventoPerfil(): void{

    this.service.getEventoIdPerfil(this.miId).subscribe((response) => {
      this.cargando =false;
      if(response!== null){
        this.handleGetSuccesfull(response);
      } else{
        this.cargando= false;
        this.openMensaje("No se puede mostrar la informacion del evento, por favor regresa al menu principal")
      }
      this.safeSrc = this.getSafeUrl(this.evento.video);




      this.fecha = new Date(this.evento.fechaApertura);
      this.metaPixelService.inicializarPixelSiEsNecesario(this.evento.metaPixel);
      this.googleAnalyticService.initializeTracking(this.evento.googleAnalytic);
      
      let x = setInterval(() => {
        let fechaFutura = this.fecha.getTime();
        let hoy = new Date().getTime();
        let distancia = fechaFutura - hoy;
        this.meses = Math.floor(distancia / (1000 * 60 * 60 * 24) / 30);
        this.semanas = Math.floor(distancia / (1000 * 60 * 60 * 24 * 7));
        this.dias = Math.floor(distancia / (1000 * 60 * 60 * 24));
        this.horas = Math.floor(
          (distancia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        this.minutos = Math.floor(
          (distancia % (1000 * 60 * 60)) / (1000 * 60)
        );
        this.segundos = Math.floor((distancia % (1000 * 60)) / 1000);
        if (distancia < 0) {
          clearInterval(x);
          this.meses = 0;
          this.semanas = 0;
          this.dias = 0;
          this.horas= 0;
          this.minutos = 0;
          this.segundos = 0;
        }
      }, 1000);
    },
    error => {
      this.cargando = false;
      this.mensajeEventoNoDisponible("Este evento no está disponible en este momento, por favor regresa a la página principal")

    });

  }


  getSafeUrl(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  handleGetSuccesfull(response) {


      this.evento = response.evento;
      this.organizadorId = response.organizador;

      this.localidades = response.localidades;

      this.mapaUrl = response.evento.url_mapa;
      this.organizadorNombre = response.organizadorNombre;


      //Hardcode evento LA CHULA id 2014
      // si ves esto luego de que pase el evento, elimínalo. No afecta nada
      //ATTE: ISAAC
      if (this.evento.id === 2014) {
        // Recorre las localidades y si alguna se llama "diamante", ponle cantidadPersonasPorTicket = 1
          this.localidades.forEach(localidad => {
            //SE HACE POR NOMBRE DE LOCALIDAD POR SI CAMBIA DE ETAPA
            if (localidad.nombre && localidad.nombre == 'DIAMANTE') {
              localidad.cantidadPersonasPorTicket = 1;
            }
          });
      }

      if (this.mapaUrl !== 'no') {
        this.mapaUrl = this.getSafeUrl(this.mapaUrl);
        this.mapaV = true;
      } else {
        this.mapaUrl = null;
        this.mapaV = false;
      }

      if(this.evento.id === 1157) {
        this.tiktokPixelService.initPixel()
      }

      

      // Obtener la URL de la imagen principal para OG
    let imagenOG = this.darURL(1); // Usamos la primera imagen de tipo 1, o puedes usar otro tipo
    
    // Asegurarse de que la URL sea absoluta
    if (imagenOG && !imagenOG.startsWith('http')) {
      // Si la URL es relativa, convertirla a absoluta usando la URL base de tu sitio
      imagenOG = `${window.location.origin}${imagenOG}`;
    }

    // Usar el SeoService para actualizar todas las meta etiquetas OG
    this.seoService.updateOgMetaTags({
      title: this.evento.nombre,
      description: this.evento.descripcion || `Evento: ${this.evento.nombre} en ${this.evento.ciudad || 'Colombia'}`,
      imageUrl: imagenOG
    });
    
    this.title.setTitle(this.evento.nombre);
      this.darURLTipos2()

      // META PIXEL 
      if (this.evento.metaPixel!=null && this.evento.metaPixel != "") {
        this.metaPixelService.inicializarPixelSiEsNecesario(this.evento.metaPixel);
      }

      //GOOGLE TAG MANAGER
      if (this.evento.googleAnalytic!=null && this.evento.googleAnalytic != "") {
         this.googleAnalyticService.initializeTracking(this.evento.googleAnalytic);
      }

  };



  darURLTipos2(){
    this.listaImagenes = this.evento.imagenes
    .filter(imagen => imagen.tipo === 2)
    .map(imagen => imagen.url);
  }
  darURL(tipo){
    const primeraImagenTipo1 = this.evento.imagenes.find(imagen => imagen.tipo === tipo);
    var urlPrimeraImagenTipo1 ="";
    if (primeraImagenTipo1) {
        urlPrimeraImagenTipo1 = primeraImagenTipo1.url;
    }
    return urlPrimeraImagenTipo1
  }

  darFecha(evento: Evento, inicio:boolean): string {

    let fechaR = evento.fecha
    if(!inicio){
      fechaR = evento.fechaFin
    }

    if(fechaR==null){
      return 'Por confirmar'
    }

    registerLocaleData(localeES, 'es');
    let dataPipe: DatePipe = new DatePipe('es');
    let Word = dataPipe.transform(fechaR, 'EEE dd');
    Word = Word[0].toUpperCase() + Word.substr(1).toLowerCase();

    let Word2 = dataPipe.transform(fechaR, 'MMM');
    Word2 = Word2[0].toUpperCase() + Word2.substr(1).toLowerCase();


    let fecha = Word + " de " + Word2 + " de " + dataPipe.transform(fechaR, 'yyyy');

    return fecha
  }



  openMensaje(mensajeT: string, openD?: string): void {
    let screenWidth = screen.width;
    let anchoDialog: string = '500px';
    let anchomax: string = '80vw';
    let altoDialog: string = '250';
    if (screenWidth <= 600) {
      anchoDialog = '100%';
      anchomax = '100%';
      altoDialog = 'auto';
    }
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: anchoDialog,
      maxWidth: anchomax,
      height: altoDialog,
      data: {
        mensaje: mensajeT,
      },
    });
  }


  openMensajeIMG(url: string): void {
    let screenWidth = screen.width;
    let anchoDialog: string = '650px';
    let anchomax: string = '80vw';
    let altoDialog: string = '250';
    if (screenWidth <= 600) {
      anchoDialog = '100%';
      anchomax = '100%';
      altoDialog = 'auto';
    }
    const dialogRef = this.dialog.open(MensajeImgComponent, {
      width: anchoDialog,
      maxWidth: anchomax,
      height: altoDialog,
      data: {
        img: url,
      },
    });
  }


  mensajeEventoNoDisponible(mensajeT: string): void {
    const dialogRef = this.dialog.open(MensajeComponent, {
      width: '600px',
      maxHeight:'250px' ,
      data: {
        mensaje: mensajeT,
      }
    });
    //navegar a la pagina principal
    dialogRef.afterClosed().subscribe(result => {
      this.router.navigate(['/']);
    });
  }

  //HARDCODE DOOM ZONA 0 
  //SI VES ESTE CODIGO LUEGO DE QUE PASE EL EVENTO ELIMINALO

accordionState = {
  combo3: false,
  combo2: false,
  viernes: false
};

// Agregar estos métodos actualizados
toggleAccordion(section: string): void {
  this.accordionState[section] = !this.accordionState[section];
}

getLocalidadesPorEtapa(cantidadPersonas: number): any[] {
  return this.localidades
    .filter(localidad => localidad.cantidadPersonasPorTicket === cantidadPersonas)
    .sort((a,b) => a.precio - b.precio);
}

getPrecioMinimo(cantidadPersonas: number): number {
  const localidadesEtapa = this.getLocalidadesPorEtapa(cantidadPersonas);
  if (localidadesEtapa.length === 0) return 0;
  
  const precios = localidadesEtapa.map(localidad => 
    (localidad.precio + localidad.servicio_iva + localidad.servicio)
  );
  
  return Math.min(...precios);
}

// Método para obtener el nombre de la etapa dinámicamente
getNombreEtapa(cantidadPersonas: number): string {
  const localidades = this.getLocalidadesPorEtapa(cantidadPersonas);
  if (localidades.length > 0) {
    return localidades[0].etapa.nombre;
  }
  
  // Fallback names si no hay localidades
  switch(cantidadPersonas) {
    case 3: return 'COMBO TRES DÍAS';
    case 2: return 'COMBO DOS DÍAS';
    case 1: return 'DÍA INDIVIDUAL';
    default: return '';
  }
}

calcularPrecioBaseTicket(localidad: Localidad): number{
    const cantidadPersonas = localidad.cantidadPersonasPorTicket;
    return cantidadPersonas * (localidad.precio );
  }

  calcularTotalPorTicket(localidad: Localidad): number{
    const cantidadPersonas = localidad.cantidadPersonasPorTicket;
    return cantidadPersonas * (localidad.precio + localidad.servicio + localidad.servicio_iva);
  }



}
